// extracted by mini-css-extract-plugin
export default {"container":"S44aq","title":"NWQOA","notes":"vE6PE","note":"Zs5fw","partnersList":"H0c0N","creditWithoutOverpayment":"nW9i8","prefix":"kdMov"};